import script from "./TagPercentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TagPercentItem.vue?vue&type=script&setup=true&lang=js"

import "./TagPercentItem.vue?vue&type=style&index=0&id=03f36621&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f36621"]])

export default __exports__